<template>
	<div class="mobile-container" :style="{ height: deviceHeight }">
		<slot name="header"></slot>
		<div class="mobile-content">
			<slot name="content"></slot>
		</div>
		<slot name="floating"></slot>
	</div>
</template>

<script setup>
import { ref } from 'vue';
import { get100vh } from '@/utils/api';
const deviceHeight = ref(get100vh());
</script>

<style lang="less" scoped>
.mobile-container {
	--b-menu-height: 44px;
	display: flex;
	flex-direction: column;

	.mobile-content {
		flex: 1;
		height: 0;
	}
}
</style>
